<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter" />
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm">
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="name">
                <el-input clearable class="w-full" v-model="form.name.value" maxlength="250" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.url') }}</label>
              <el-form-item prop="url">
                <el-input clearable class="w-full" v-model="form.url.value" maxlength="2500" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.type') }}</label>
              <el-form-item prop="notificationType">
                <base-el-select class="w-full" :options="notificationTypes" v-model="form.notificationType.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.active') }}</label>
              <el-form-item prop="activo">
                <base-el-select class="w-full" :options="values" v-model="form.activo.value" clearable :placeholder="$t('companies.active_yes_no')" />
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"
        :loading="isLoading" />
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'webhooks',
      isOpen: this.panelOpen,
      links: [],
      form: {
        name: { label: i18n.t('app.name'), value: '' },
        url: { label: i18n.t('app.url'), value: '' },
        notificationType: { label: i18n.t('app.type'), value: '', labelValue: '' },
        activo: { label: i18n.t('app.active'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    isLoading: function () {
      return this.$store.getters.isLoading
    },
    notificationTypes: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_NOTIFICATION']
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.url.value = _temp.url !== undefined && _temp.url.value !== '' ? _temp.url.value : ''
        this.form.notificationType.value = _temp.notificationType !== undefined && _temp.notificationType.value !== '' ? _temp.notificationType.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
      }
    },
    watchFormHandler: function () {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        name: { label: i18n.t('app.name'), value: '' },
        url: { label: i18n.t('app.url'), value: '' },
        notificationType: { label: i18n.t('app.type'), value: '', labelValue: '' },
        activo: { label: i18n.t('app.active'), value: '' },
      }
    },
    applyFilters: function () {
      if (this.form.notificationType.value !== '') this.controlLabelNotificationType(this.form.notificationType.value)
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    controlLabelNotificationType: function (value) {
      const notificationType = this.notificationTypes.filter(x => x.value === value)
      if (notificationType !== null && notificationType !== undefined) this.form.notificationType.labelValue = notificationType[0].label
    },
  }
}
</script>

<style lang="scss" scoped></style>
